<template>
  <div>
    <section class="hero hero-lp hero-easter is-clipped">
      <div class="hero-body ">
        <div class="container is-relative">
          <div class="columns pt-5 pb-5 is-vcentered is-variable is-1"
            v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <div class="column is-7-tablet is-6-desktop has-text-centered-mobile titlearea">
              <h1
                class="title has-background-primary is-inline-block is-size-4 is-size-2-tablet has-text-weight-bold  pr-1 pl-1 mb-5">
                ADAC Hotelgutschein
              </h1>
              <h2 class="title easter-title is-size-3 is-size-2-tablet has-text-weight-bold has-text-black">
                <span class="is-inline-block-tablet is-block-mobile has-text-white">Frühlings&shy;erwachen <span
                    class="is-hidden-mobile">-</span> </span> <span class="is-inline-block">Endlich wieder raus!</span>
              </h2>
              <!-- <p class="has-text-white-ter has-text-weight-bold is-size-5">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</p> -->
            </div>
            <div class="column has-text-centered">
              <img fetchpriority="high"
                :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=700&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/ostern.png`"
                alt="Ostern" width="600" height="397" />
            </div>
          </div>
          <img fetchpriority="high" class="hero-easter__bunny"
            :src="`https://assets.urlaubsgutschein.kaufen/whitelabel/adac/campaigns/osterhase.svg`" alt="Osterhase"
            width="118" height="300" />
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile advantages-lp">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>

    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <h2 class="title">Ihr Aktiv- & Erholungsurlaub – bis zu 70% günstiger</h2>
            <!-- <h3 class="subtitle has-text-weight-bold">subtitle</h3> -->
            <div class="content">
              <p>
                Der Frühling wärmt, erfreut und stimmt uns optimistisch: endlich wieder raus! Aufatmen, die Natur
                genießen, den Körper in Schwung bringen und der Seele was Gutes tun. Wir alle sehnen uns nach Urlaub.
                Den können Sie jetzt schon planen und dabei riesig sparen. Wie wäre es mit ein paar
                Tagen Bergfreuden in den Dolomiten, einem Superior Golf- Wochenende im Bayerischen Wald oder einem
                Relaxaufenthalt im Thermenhotel in der Steiermark? Die Gutscheine sind flexibel und bis zu 3 Jahre
                einlösbar, sogar übertragbar. Einfach kaufen, ausdrucken und sich oder den Liebsten zu
                Ostern echte Vorfreude schenken!
              </p>
            </div>
          </div>

          <!-- <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
            <h2 class="title">Jetzt schon an Weihnachten denken</h2>
            <div class="content">
              <p>
                Ab 21. November 2020 ist es soweit: Wir starten in die <strong>Black Friday Woche!</strong> Sparen Sie bis zum 29.11. nochmals auf unsere bereits deutliche reduzierten Hotelgutscheine. Lassen Sie sich diese Chance nicht entgehen und sichern Sie sich einen Urlaubsgutschein für Ihren
                nächsten Kurzurlaub oder kaufen Sie bereits jetzt ein Weihnachtsgeschenk für Ihre Liebsten. Unsere Black Friday Angebote finden Sie hier.
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <section class="section section-offers">
      <div class="container">
        <div class="columns" v-if="offers.length == 0">
          <div class="column is-8 is-offset-2">
            <div class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold"
              role="status" aria-live="polite">
              <b-icon icon="sad-cry" size="is-large"></b-icon>
              <br />Leider sind keine Angebote vorhanden!
            </div>
          </div>
        </div>

        <div v-if="offers.length > 0">
          <h2 class="title is-size-4 has-text-centered">Angebote enden in</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <!-- bzw für normale suche haspromotion | Custom:easter -->

          <div class="columns is-multiline is-variable is-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--easter" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
import OfferApi from '@/api/offer-api'
export default {
  name: 'easter',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
  },
  data() {
    return {
      offers: [],
    }
  },
  computed: {
    campaignTimer: function () {
      let endDate = new Date('2021-04-06 23:59') - new Date()
      return endDate
    },
  },
  async mounted() {
    this.offers = await OfferApi.getOffersWithCustomPromotion('ostern21')
  },
  metaInfo() {
    return {
      title: 'Frühlingserwachen - Endlich wieder raus!',
      meta: [{ name: 'description', content: 'Sichern Sie sich einen ADAC Hotelgutschein zu Ostern - Ihr Aktiv- & Erholungsurlaub – bis zu 70% günstiger!' }],
      link: [{ rel: 'preconnect', href: '//maps.googleapis.com', crossorigin: 'anonymous' }],
    }
  },
}
</script>

<style lang="scss">
.hero-easter {
  background-color: #86a935;

  .hero-body {
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
}

.easter-title {
  @media screen and (min-width: 1024px) {
    font-size: 3rem !important;
  }

  @media screen and (min-width: 1216px) {
    font-size: 3.5rem !important;
  }

  @media screen and (min-width: 1408px) {
    font-size: 4rem !important;
  }
}

.offer--easter {
  .card-tag .tag {
    background-color: red !important;
  }
}

.hero-easter__bunny {
  position: absolute;
  bottom: -10vw;
  right: 2vw;
  width: 28vw;

  @media screen and (min-width: 769px) {
    width: 17vw;
    right: -0.5rem;
  }

  @media screen and (min-width: 1024px) {
    bottom: -5rem;
    right: -3.4rem;
    width: 170px;
  }
}
</style>
